import PWCore, {Address, Amount, AddressType, EthProvider, IndexerCollector} from '@lay2/pw-core';
import { AppSettings } from "./AppSettings";
import {NervosSettings} from "./NervosSettings";
import { Wallet } from './Wallet';
import { ProviderKeys } from '../data/ProviderKeys';

export class PortalWallet extends Wallet {
    provider: any;
    collector: IndexerCollector;
    worker: PWCore | undefined;
    nervosSettings = NervosSettings.TestNet;
    address: Address| undefined;

    constructor() {
        super();
        this.walletProvider = ProviderKeys.PortalWallet;

        this.provider = new EthProvider(); // A built-in Provider for Ethereum wallets like MetaMask.
        this.collector = new IndexerCollector(this.nervosSettings.Indexer); // A Collector to retrive cells from the CKB Indexer RPC.
    }

    async connect(): Promise<string> {
        this.worker = await new PWCore(this.nervosSettings.RPC)
            .init(this.provider, this.collector);
        const ethProvider = this.provider as EthProvider;
        this.address = ethProvider.address;
        this.originalAccount = this.address.addressString;
        this.account = this.address.toCKBAddress();
        console.log(`ETH address: ${this.originalAccount}`);
        console.log(`Nervos address: ${this.account}`);
        return this.account;
    }

    async signMessage(message: string): Promise<string> {
        let signature = "";
        //(this.provider as EthProvider).sign()
        return signature;
    }

    async verifyMessage(): Promise<boolean> {
        return false;
    }
}